module.exports = __webpack_public_path__ + "img/content.8f57d89e.png";